import Request from "./request";

const reminds = "/reminds";
export default {
  async getMessge(query) {
    return Request.get(
      reminds,
      query
    );
  },
 
};
